import * as React from 'react';
import classnames from 'classnames';

import PageHeading from '../page-heading/PageHeading';

import './page-section.scss';

import type { PageSectionTitle } from 'types';

type Props = {
  title?: string,
  style: 'flat' | 'volume' | 'none',
  padding: 'normal' | 'medium' | 'large' | 'none',
  margin: 'normal' | 'small' | 'medium' | 'none' | 'top-none',
  border?: 'normal' | 'none',
  customClass?: string,
  note?: React.ReactNode,
  afterTitle?: React.ReactNode,
  children: React.ReactNode,
  id?: string,
  titleProps: PageSectionTitle | undefined | null
};

class PageSection extends React.PureComponent<Props> {
  static defaultProps = {
    note: null,
    style: 'volume',
    padding: 'large',
    margin: 'normal',
    border: 'normal',
    titleProps: null
  };

  render(): React.ReactNode {
    const {
      title,
      titleProps,
      children,
      style,
      padding,
      id,
      margin,
      border,
      customClass,
      note,
      afterTitle
    } = this.props;

    const classes = classnames(
      'page-section', {
        [`page-section--margin-${margin}`]: margin,
        [String(customClass)]: customClass
      });

    const contentClasses = classnames(
      'page-section__section', {
        [`page-section__section--padding-${padding}`]: padding
      });

    const borderClasses = classnames({
      [`page-section__section--style-${style}`]: style,
      [`page-section__section--border-${String(border)}`]: border
    });

    return (
      <section
        id={id}
        className={classes}
      >
        {
          title && (
            <PageHeading
              heading={title}
              color="light"
              {...titleProps}
            />
          )
        }
        {afterTitle}
        <div className={borderClasses}>
          {note}
          <div className={contentClasses}>
            {children}
          </div>
        </div>
      </section>
    );
  }
}

export default PageSection;
